<rt-dropdown #dropdownComponent [width]="$any(width())" (click)="$event.preventDefault()">
  <ng-template [ngTemplateOutlet]="selectHeaderTemplate() || headerTemplate" />

  @if (hasSearch()) {
    <div class="header">
      <rt-form-field>
        <rt-input
          #input
          (keydown.esc)="keydownEscape($event)"
          [disableInvalidStyles]="true"
          [autoFocus]="true"
          [formControl]="control"
          [placeholder]="text() && text().placeholder"
          [hasClearButton]="true"
          [loading]="loading()"
          (reset)="control.reset()"
          variant="rounded"
        >
          <rt-icon prefix [name]="'search'" />
        </rt-input>
      </rt-form-field>
    </div>
  }

  @if (activeSuggestions.rows.length > 0) {
    <rt-attributes-select-list
      [maxHeight]="maxDropdownHeight()"
      [suggestionsListData]="suggestions"
      [createNewItemId]="CREATE_NEW_ITEM_ID"
      [createNewAttr]="createNewAttr"
      [highlightedId]="highlight?.id ?? null"
      [markSelected]="markSelected()"
      [selected]="selected()"
      (saveAttribute)="onSaveAttribute($event, 'suggestion')"
      (loadMore)="onLoadMore()"
    />
  }

  @if (errors && errors.maxlength) {
    <rt-dropdown-item>
      {{ maxLengthExceeded }}
    </rt-dropdown-item>
  }

  @if (activeSuggestions.rows.length === 0 && loading()) {
    <rt-dropdown-item>
      <div [style.height]="maxDropdownHeight() || '300px'"></div>
    </rt-dropdown-item>
  }

  @if (!showAlreadyExists() && control.valid) {
    @if (activeSuggestions.rows.length === 0 && preventCreateMessageVisible && !createDisabled()) {
      <rt-dropdown-item>
        <ng-container *ngTemplateOutlet="emptyResultsWithNoAbilityToCreateNewWithValue" />
      </rt-dropdown-item>
    }

    @if (activeSuggestions.rows.length === 0 && preventCreateMessageVisible && createDisabled()) {
      <rt-dropdown-item (click)="dispose.emit()">
        <ng-container *ngTemplateOutlet="emptyResultsWithCreatingDisabled" />
      </rt-dropdown-item>
    }

    @if (activeSuggestions.rows.length > 0 && preventCreateMessageVisible && !createDisabled()) {
      <rt-dropdown-item>
        <ng-container *ngTemplateOutlet="nonEmptyResultsWithNoAbilityToCreateNew" />
      </rt-dropdown-item>
    }

    @if (
      !preventCreateMessageVisible &&
      activeSuggestions.rows.length === 0 &&
      !canCreate() &&
      !createDisabled()
    ) {
      <rt-dropdown-item (click)="dispose.emit()">
        <ng-container *ngTemplateOutlet="emptyResultsWithNoAbilityToCreateNew" />
      </rt-dropdown-item>
    }

    @if (!preventCreateMessageVisible && activeSuggestions.rows.length === 0 && createDisabled()) {
      <rt-dropdown-item (click)="dispose.emit()">
        <ng-container *ngTemplateOutlet="emptyResultsWithCreatingDisabled" />
      </rt-dropdown-item>
    }

    @if (activeSuggestions.rows.length === 0 && canCreate() && !createDisabled()) {
      <rt-dropdown-item (click)="onSaveAttribute({ value: control.value }, 'input')">
        <ng-container *ngTemplateOutlet="createNewAttr" />
      </rt-dropdown-item>
    }
  }

  @if (showAlreadyExists()) {
    <rt-dropdown-item>
      <ng-container *ngTemplateOutlet="attrAlreadyExists" />
    </rt-dropdown-item>
  }

  @if (selectFooterTemplate) {
    <ng-template [ngTemplateOutlet]="selectFooterTemplate" />
  }
</rt-dropdown>

<ng-template #maxLengthExceeded>
  <div class="special-item with-padding">
    <div class="head">{{ text().maxLengthExceeded }}</div>
  </div>
</ng-template>

<ng-template #nonEmptyResultsWithNoAbilityToCreateNew>
  <div class="special-item with-padding">
    <div class="head">"{{ control.value }}" {{ text().notFound }}</div>
    <div class="value">{{ text().noAbilityToCreateAttr }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithNoAbilityToCreateNewWithValue>
  <div class="special-item">
    <div class="head">{{ text().noAbilityToCreateAttr }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithNoAbilityToCreateNew>
  <div class="special-item">
    <div class="head">{{ text().emptyResults }}</div>
    <div class="value">{{ text().noAbilityToCreateAttr }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithCreatingDisabled>
  <div class="special-item">
    <div class="head">{{ text().emptyResults }}</div>
  </div>
</ng-template>

<ng-template #attrAlreadyExists>
  <div class="special-item">
    <div class="head">{{ text().attrAlreadyExists }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>

<ng-template #createNewAttr>
  <div class="special-item clickable">
    <div class="head">{{ text().createNewAttr }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>
<ng-template #headerTemplate>
  <rt-dropdown-header [fullWidthTitle]="true">
    {{ text()?.placeholder }}
  </rt-dropdown-header>
</ng-template>
